// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-swipe-overlay";
var _2 = "ra-quiz-swipe-overlay-container";
var _3 = "ra-quiz-swipe-overlay-overlay-text";
export { _1 as "quizSwipeOverlayCls", _2 as "quizSwipeOverlayContainerCls", _3 as "quizSwipeOverlayTextCls" }
